<template>
  <div id="index" class="centert">
    <div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
         @click="fha">
      顶部
    </div>
    <!-- VR头部 -->
    <div class="vrtop">

      <div class="VRwarp"   style="height: 600px; ">
        <iframe width="100%" height="100%" src="https://www.720yun.com/t/9evkzl7qrpm?scene_id=79083128"></iframe>
    </div>
    </div>
    <!-- 企业和船期定位 -->
    <div class="shiplocation">
      <shiplocation></shiplocation>
    </div>
    <div id="qydq">

    </div>
    <!-- 综合性能 -->
    <div class="comprehensive" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);">
      <comprehensive></comprehensive>
    </div>

    <!-- 导航 -->
    <div class="Navigation" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);">
      <Navigation></Navigation>
    </div>
<!--    <div id="xptj">-->

<!--    </div>-->
    <!-- 新品推荐 -->
<!--    <div class="NewArrivals">-->
<!--      <NewArrivals></NewArrivals>-->
<!--    </div>-->

    <!-- 广告1 -->
    <div class="advertisementone">
      <advertisementone></advertisementone>
    </div>
    <div id="ctxz">

    </div>
    <!-- 船舶船型 -->
    <div class="ShipchartLibrary">
      <ShipchartLibrary></ShipchartLibrary>
    </div>

    <!-- 广告2 -->
    <div class="advertisementtwo">
      <advertisementtwo></advertisementtwo>
    </div>
    <div id="hhdt">

    </div>
    <!-- 地图 -->
    <div class="mapss">
      <mapss></mapss>
    </div>
    <div id="rwdt">

    </div>
    <!-- 任务大厅 -->
    <!-- <div class="MissionHall">
      <MissionHall></MissionHall>
    </div> -->
<!--    <div class="Expertthinktank" style="height: 410px;">-->
<!--      <Expertthinktanks></Expertthinktanks>-->
<!--    </div>-->
    <div id="zjzk">

    </div>
    <!-- 专家智库 -->
    <div class="Expertthinktank" style="height: 410px;">
      <Expertthinktank></Expertthinktank>
    </div>
    <div id="qzzp">

    </div>
    <!-- 求职招聘 -->
<!--    <div class="Jobrecruitment">-->
<!--      <Jobrecruitment></Jobrecruitment>-->
<!--    </div>-->

    <!-- 广告3 -->
    <div class="advertisementthree">
      <advertisementthree></advertisementthree>
    </div>
    <div id="dk">

    </div>
    <!-- 交流中心 -->
<!--    <div class="Bigcoffeegathering">-->
<!--      <Bigcoffeegathering></Bigcoffeegathering>-->
<!--    </div>-->
    <div id="jrsp">

    </div>
    <!-- 今日视频 -->
    <div class="todayvideo">
      <todayvideo></todayvideo>
    </div>
    <div id="hyzx">

    </div>
    <!-- 广告4 -->
    <div class="advertisementfore">
      <advertisementfore></advertisementfore>
    </div>

    <!-- 行业资讯 -->
    <div class="Industryinformation">
      <Industryinformation></Industryinformation>
    </div>
    <div id="zhhy">

    </div>
    <!-- 展会会议 -->
    <div class="Exhibitionmeeting">
      <Exhibitionmeeting></Exhibitionmeeting>
    </div>
    <div id="txl">

    </div>
    <!-- 通讯录 -->
    <div class="maillist">
      <maillist></maillist>
    </div>
    <div id="hyhd">

    </div>
    <!-- 会员活动 -->
<!--    <div class="Membershipactivities">-->
<!--      <Membershipactivities></Membershipactivities>-->
<!--    </div>-->
    <div id="bkqk">

    </div>
    <!-- 报刊期刊 -->
    <div class="Expertthinktank" style="height: 400px;">
      <Newspapersperiodicals></Newspapersperiodicals>
    </div>
    <div id="zbtg">

    </div>
    <div id="zbhd">

    </div>
    <!-- 直播互动 -->
    <div class="Expertthinktank">
      <zbhd></zbhd>
    </div>

    <!-- 招标通告 -->
<!--    <div class="Expertthinktank">-->
<!--      <zbgg></zbgg>-->
<!--    </div>-->

<!--    <div id="bmzx">-->

<!--    </div>-->
    <!-- 便民服务 -->
    <div class="Convenientservice">
      <Convenientservice></Convenientservice>
    </div>

    <!-- 尾标签 -->
    <div>
      <myfooter></myfooter>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      vrShow: false,
    }
  },
  methods: {
    ydHome() {
      this.vrShow = true
      window.scrollTo(0, 0)
    },
    fha() {
      const goToTop = () => window.scrollTo(0, 0);

      goToTop();
    }
  },
  components: {
    // 尾标签,
    myfooter: resolve => require(['@/components/myfooter'], resolve),
    //企业和船期定位
    shiplocation: resolve => require(['@/components/shiplocation'], resolve),
    //直播互动
    zbhd: resolve => require(['@/components/zbhd'], resolve),
    //综合性能
    comprehensive: resolve => require(['@/components/comprehensive'], resolve),
    //导航
    Navigation: resolve => require(['@/components/Navigation'], resolve),
    //新品推荐
    NewArrivals: resolve => require(['@/components/NewArrivals'], resolve),
    //广告1
    advertisementone: resolve => require(['@/components/advertisementone'], resolve),
    //船舶船型
    ShipchartLibrary: resolve => require(['@/components/ShipchartLibrary'], resolve),
    //广告2
    advertisementtwo: resolve => require(['@/components/advertisementtwo'], resolve),
    //地图
    mapss: resolve => require(['@/components/mapss'], resolve),
    //任务大厅
    MissionHall: resolve => require(['@/components/MissionHall'], resolve),
    //专家智库
    Expertthinktank: resolve => require(['@/components/Expertthinktank'], resolve),
    Expertthinktanks: resolve => require(['@/components/Expertthinktanks'], resolve),
    //求职招聘
    Jobrecruitment: resolve => require(['@/components/Jobrecruitment'], resolve),
    //广告3
    advertisementthree: resolve => require(['@/components/advertisementthree'], resolve),
    //交流中心
    Bigcoffeegathering: resolve => require(['@/components/Bigcoffeegathering'], resolve),
    //今日视频
    todayvideo: resolve => require(['@/components/todayvideo'], resolve),
    //广告4
    advertisementfore: resolve => require(['@/components/advertisementfore'], resolve),
    //行业资讯
    Industryinformation: resolve => require(['@/components/Industryinformation'], resolve),
    //展会会议
    Exhibitionmeeting: resolve => require(['@/components/Exhibitionmeeting'], resolve),
    //通讯录
    maillist: resolve => require(['@/components/maillist'], resolve),
    //会员活动
    Membershipactivities: resolve => require(['@/components/Membershipactivities'], resolve),
    //便民服务
    Convenientservice: resolve => require(['@/components/Convenientservice'], resolve),
    //报刊期刊
    Newspapersperiodicals: resolve => require(['@/components/Newspapersperiodicals'], resolve),
    //招标公告
    zbgg: resolve => require(['@/components/zbgg'], resolve),
  },
}
</script>

<style>
.centert {
  width: 1200px;
  margin: 0 auto;
}

.vrtop {
  width: 100%;
  height: 600px;
}

.shiplocation {
  width: 100%;
  height: 150px;
  margin-top: 20px;
}

.comprehensive {
  width: 100%;
  height: 450px;
  margin-top: 20px;
  /* background-color: blanchedalmond; */
}

.Navigation {
  width: 100%;
  height: 500px;
  margin-top: 20px;
}

.NewArrivals {
  width: 100%;
  height: 350px;
  margin-top: 20px;
}

.advertisementone {
  width: 100%;
  height: 125px;
  margin-top: 20px;
}

.ShipchartLibrary {
  width: 100%;
  height: 330px;
  margin-top: 20px;
}

.advertisementtwo {
  width: 100%;
  height: 125px;
  margin-top: 20px;
}

.mapss {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}

.MissionHall {
  width: 100%;
  height: 560px;
  margin-top: 20px;
}

.Expertthinktank {
  width: 100%;
  height: 310px;
  margin-top: 20px;
}

.Jobrecruitment {
  width: 100%;
  height: 650px;
  margin-top: 20px;
}

.advertisementthree {
  width: 100%;
  height: 125px;
  margin-top: 20px;
}

.Bigcoffeegathering {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}

.todayvideo {
  width: 100%;
  height: 666px;
  margin-top: 20px;
}

.advertisementfore {
  width: 100%;
  height: 125px;
  margin-top: 20px;
}

.Industryinformation {
  width: 100%;
  height: 500px;
  margin-top: 20px;
}

.Exhibitionmeeting {
  width: 100%;
  height: 490px;
  margin-top: 20px;
}

.maillist {
  width: 100%;
  height: 380px;
  margin-top: 20px;
}

.Membershipactivities {
  width: 100%;
  height: 666px;
  margin-top: 20px;
}

.Convenientservice {
  width: 100%;
  height: 400px;
  margin-top: 20px;
}

.VRwarp {
  height: 100vh;
  width: 100%;
}

.VRwarp>img {
  width: 100%;
  height: 100%;
}
</style>
